import { render, staticRenderFns } from "./OtherQuestionnaire.vue?vue&type=template&id=6a82fd71&scoped=true&"
import script from "./OtherQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./OtherQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a82fd71",
  null
  
)

export default component.exports